import { render, staticRenderFns } from "./ManifestPricingTable.vue?vue&type=template&id=64283ee5&"
import script from "./ManifestPricingTable.vue?vue&type=script&lang=js&"
export * from "./ManifestPricingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports